import styled from 'styled-components';

import { ModalConfirmationFooter } from 'ui/modal';
import { spacing, colors } from 'ui/theme';

export const StyledErrorModalContainer = styled.div`
  dialog {
    padding: ${spacing.plusHalf};
  }

  dialog > span {
    align-items: center;
    display: flex;
    column-gap: ${spacing.quarter};
  }

  dialog > span > span:nth-child(2) {
    color: ${colors.textSecondary};
  }
`;

export const ErrorModalFooterHideChild = styled(ModalConfirmationFooter)`
  display: none;
`;
